import { render } from "./Invitations.vue?vue&type=template&id=be06fad4&scoped=true"
import script from "./Invitations.vue?vue&type=script&lang=js"
export * from "./Invitations.vue?vue&type=script&lang=js"

import "./Invitations.vue?vue&type=style&index=0&id=be06fad4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be06fad4"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
